import { InsuranceAction, InsuranceActionListenerList, LegacyInsuranceAction } from '@typesApp/InsuranceActionListener'

export const invokeInsuranceActionListeners = (
  listenerList: InsuranceActionListenerList | undefined,
  action: InsuranceAction
) => {
  const listeners = listenerList?.listeners ?? []
  const isLegacy = listenerList?.isLegacy

  listeners.length && console.debug('Invoking %s insurance action listener(s)', listeners.length)

  const insuranceAction = mapAction(action, isLegacy)
  try {
    listeners.forEach(handler => typeof handler === 'function' && handler(insuranceAction))
  } catch (error) {
    console.warn('Error invoking insurance action listener', error)
  }
}

/**
 * Ensure we send the correct action as existing brands expect 'sync' whereas newer integrations expect 'apply'.
 * Once all integrations are up to date, we can remove the mapping.
 */
const mapAction = (action: InsuranceAction, isLegacy?: boolean): InsuranceAction | LegacyInsuranceAction => {
  if (action === 'apply' && isLegacy) {
    return 'sync'
  }
  return action
}
